


























import DocumentLink from '@/components/DocumentLink'

export default {
    name: 'LogoSlider'

    components:
        DocumentLink: DocumentLink

    props: ['document']

    computed:
        isDark: -> @$parent.isDark

    data: ->
        fields: @defaultFields()

    methods:
        defaultFields: ->
            items: []

        setContent: (document) ->
            fields =
                items: document.items
            $.extend @fields, fields
        
    created: ->
        @setContent @document
}
